import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth.service';
import { DataService } from '../data.service';
import { StudyReportSearchItem } from '../../model/study-report-search-item';

@Injectable({
  providedIn: 'root'
})
export class StudyReportUnificationService {

  constructor(private dataService: DataService) { }

  private readonly getStudyReportUnificationCandidatesEndPoint: string =
      '/studyReportUnification/getStudyReportUnificationCandidates/';
  private readonly createStudyReportUnificationEndPoint: string =
      '/studyReportUnification/createStudyReportUnification/';
  private readonly undoStudyReportUnificationEndPoint: string =
      '/studyReportUnification/undoStudyReportUnification/';

  async getStudyReportUnificationCandidates(physicianId: number, studyReportId: number): Promise<StudyReportSearchItem[]> {
    const params = { studyReportId: studyReportId,  physicianId: physicianId };
    return await this.dataService
      .get<StudyReportSearchItem[]>(this.getStudyReportUnificationCandidatesEndPoint, params).toPromise();
  }

  async createStudyReportUnification(studyReportId: number, studyReportChildsId: number[]): Promise<boolean> {
    const params = { studyReportId: studyReportId,  studyReportChildsId: studyReportChildsId }; 
    return await this.dataService
      .post<boolean>(this.createStudyReportUnificationEndPoint, params).toPromise();
  }

  async undoStudyReportUnification(studyReportId: number): Promise<boolean> {
    const params = { studyReportId: studyReportId };
    return await this.dataService
      .post<boolean>(this.undoStudyReportUnificationEndPoint, params).toPromise();
  }
}
